import { render, staticRenderFns } from "./ServerGroupEdit.vue?vue&type=template&id=418b1b52"
import script from "./ServerGroupEdit.vue?vue&type=script&lang=js"
export * from "./ServerGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports